// extracted by mini-css-extract-plugin
module.exports = {"root":"Filter-module--root--Bh3bd"};